import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c60e8be"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manage-modal" }
const _hoisted_2 = { class: "org-modal-contain" }
const _hoisted_3 = { class: "first-row tw-flex tw-w-full tw-justify-between tw-items-center" }
const _hoisted_4 = { class: "search-box tw-flex tw-justify-center !tw-bg-[#fcfcfd]" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/img/search_black_icon.svg",
  alt: "search_icon"
}, null, -1))
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { class: "tw-flex tw-items-center" }
const _hoisted_8 = { class: "btn-access-request" }

import store from "@/store";
import { computed, onMounted, reactive, ref, Ref, watch } from "vue";
import HeaderModal from "@/components/common/headerModal.vue";
import utilities, { getComponentUiText } from "@/utils/utilities";
import ManageOrgTable from "@/components/common/setting/manageOrgTable.vue";
import ButtonBulkActions from "../common/setting/buttonBulkActions.vue";
import ButtonFilter from "../common/setting/buttonFilter.vue";
import IconButton from "../common/iconButton.vue";
import router from "@/router";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IOrgDetails } from "@/interfaces/orgInterfaces";
import {
  deleteOrgRequest,
  leaveOrg,
  putVerificationRequestOrg,
} from "@/services/org";
import {
  localStorageBoolean,
  MODAL_NAME,
  requestAccessDetailModalType,
  successStatusCodes,
} from "@/utils/constants";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";
import { showErrorAPI } from "@/services/apiRoutes";
import { Org } from "@/services/apiRoutes/routes";
import ToggleSwitch from "@/components/common/toggleSwitch.vue";
import { IModalMessage } from "@/interfaces/common/common";

export type orgItem = {
  id: number;
  name: string;
  icon: string;
  isHome: boolean;
  isShowMoreModal: boolean;
};

export type roleItem = {
  role: string;
  isStart: boolean;
};

export type orgItemTemp = {
  id: number;
  name: string;
  roles: Array<roleItem>;
  isShowMoreModal: boolean;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'manageOrgDropDown',
  props: {
  modelValue: {
    type: Boolean,
    required: false,
  },
  updateModal: {
    type: Boolean,
    required: false,
  },
  searchKey: {
    type: String,
    required: false,
    default: () => "",
  },
},
  emits: ["closeModal", "createOrg", "leaveOrg"],
  setup(__props, { emit }) {

const props = __props;



const isShowArchived = ref(false);
const orgListVerifyRef = ref<any[]>([]);
const orgList = computed(() => store.state.Org.orgsList);
const currentOrg = computed(() => store.state.Org.currentOrg);
const orgListVerify = computed(() => store.state.Org.orgListVerify);

const tableData = computed(() => {
  const orgListDefault = orgList.value.filter((org) => {
    org.isDefaultVerified = true;
    return org.name.toLowerCase().includes(search.value.toLowerCase());
  });
  const orgListUpdate = orgListVerifyRef.value.filter((org) => {
    org.name = org.name || org.nameShort;
    const isNamePassed =
      !org.name || org.name?.toLowerCase().includes(search.value.toLowerCase());
    const isArchivedPassed = !isShowArchived.value ? !org.isArchived : true;
    return isNamePassed && isArchivedPassed;
  });
  return orgListDefault.concat(orgListUpdate);
});



onMounted(async () => {
  await store.dispatch("Org/fetchOrgListVerify");
});

watch(orgListVerify, () => {
  orgListVerifyRef.value = [...orgListVerify.value];
});

watch(isShowArchived, async () => {
  if (isShowArchived.value) {
    await store.dispatch("Org/fetchOrgListVerify", { includeArchived: true });
  }
});

watch(
  () => props.modelValue,
  (value) => {
    if (value) {
      fetchOrgs();
    }
  },
);

watch(
  () => props.updateModal,
  (value) => {
    if (value) {
      fetchOrgs(true);
    }
  },
);
watch(
  () => props.searchKey,
  () => {
    search.value = props.searchKey;
  },
);
const search = ref(props.searchKey);
const showBulkActions: Ref<boolean> = ref(false);
let orgSelected: orgItemTemp[] = reactive([]);
const orgSelectedCount = ref(0);

const defaultUiText = computed(() => store.state.LanguagePicker.defaultUiText);
const languageSelectedText = computed(
  () => store.state.LanguagePicker.languageSelectedText,
);
const getUiText = (id: string, isArray = false) => {
  return utilities.getUiText(
    id,
    languageSelectedText.value,
    defaultUiText.value,
    isArray,
  );
};

const organizationManageTableFields = [
  {
    key: "name",
    label: getUiText("app-component-custom-table-header-name-1"),
    thClass: ["header-org-name !tw-bg-[#fcfcfd]"],
  },
  {
    key: "userRoles",
    label: getUiText("app-manage-orgs-header-role-1"),
    tdClass: "tw-w-3/4",
    thClass: ["header-roles !tw-bg-[#fcfcfd]"],
  },
  {
    key: "status",
    label: getUiText("app-manage-orgs-header-status-1"),
    tdClass: "tw-w-1/4",
    thClass: ["header-roles !tw-bg-[#fcfcfd]"],
  },
  {
    key: "actionManage",
    label: "",
    thClass: ["header-actions !tw-bg-[#fcfcfd]"],
  },
];

const fetchOrgs = async (isUpdate = false) => {
  await store.dispatch("Org/fetchOrgList");
  if (isUpdate && orgList.value.length === 0) {
    closeModal();
  }
};

const closeModal = () => {
  emit("closeModal");
};

const openCreateOrgModal = (
  data: any,
  mode: keyof typeof requestAccessDetailModalType,
) => {
  // closeModal();
  emit("createOrg", { data, mode });
};

const handleSelectOrg = (orgs: orgItemTemp[], isSelectAll = false) => {
  if (isSelectAll) {
    orgSelected = Object.assign([], orgs);
  } else {
    orgs.forEach((org) => {
      const index = orgSelected.findIndex((item) => item.id === org.id);
      if (index !== -1) orgSelected.splice(index, 1);
      else orgSelected.push(org);
    });
  }

  if (orgSelected.length >= 1) showBulkActions.value = true;
  else showBulkActions.value = false;
  orgSelectedCount.value = orgSelected.length;
};

const switchOrg = (org) => {
  store.dispatch("Org/switchOrg", { orgId: org.id });
  closeModal();
};

const leaveOrgMembership = async (org: IOrgDetails) => {
  try {
    const res = await leaveOrg(org.id);

    if (res.status === successStatusCodes.OK) {
      store.dispatch("Org/fetchOrgList");
      showToastMessage(
        true,
        getUiText("app-manage-orgs-leave-org-toast-success-message-1"),
      );
    }
  } catch (error: any) {
    if (error && error.data) {
      showErrorAPI(error, Org.leaveOrg);
    }
  }
};

const gotToRequest = () => {
  emit("closeModal");
  router.push({
    name: "ManageAccess",
    query: { isOpenRequestModal: localStorageBoolean.true },
  });

  EventEmitter.emit(EmitterEvents.OPEN_REQUEST_MODAL);
};

const showToastMessage = (success = true, message: string) => {
  const emitData: IToastMessage = {
    variant: success ? ToastVariant.SUCCESS : ToastVariant.ERROR,
    message: message,
  };

  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};

const handleDeleteOrgRequest = async (id: string) => {
  try {
    await deleteOrgRequest({ orgVerifyIds: [id] });
    orgListVerifyRef.value = orgListVerifyRef.value.filter(
      (item) => item.id !== id,
    );
  } catch (error) {
    showErrorAPI(error, Org.deleteOrgRequest);
  }
};

const handleArchiveOrgRequest = async (org: any, isArchived: boolean) => {
  try {
    await putVerificationRequestOrg(org.id, { isArchived });
    orgListVerifyRef.value.some((item) => {
      if (item.id === org.id) {
        org.isArchived = isArchived;
        return true;
      }
      return false;
    });
  } catch (error) {
    showErrorAPI(error, Org.editRequestVerification);
  }
};

const openModalLeaveOrg = (org: IOrgDetails) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-settings-team-members-profile-modal-remove-access-button-1",
      ),
      description: getComponentUiText(
        "app-settings-organisation-manage-access-remove-access-modal-helper-text-a-1",
      ),
      list: [],
      buttonText: getComponentUiText(
        "app-settings-team-members-profile-modal-remove-access-button-1",
      ),
      isShowBtnCancel: true,
      buttonRed: true,
      hiddenHelp: false,
    },
    events: {
      "update:data": () => leaveOrgMembership(org),
    },
  };
  EventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderModal, {
        "header-text": getUiText('app-manage-orgs-heading-1'),
        onCloseModal: closeModal
      }, null, 8, ["header-text"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
            type: "text",
            placeholder: getUiText('app-table-search-prompt-text-1'),
            class: "tw-placeholder-[#B7B7B7] tw-font-[500] !tw-bg-[#fcfcfd]"
          }, null, 8, _hoisted_6), [
            [_vModelText, search.value]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "button-show-archived tw-p-4 !tw-bg-[#fcfcfd] !tw-border !tw-border-solid !tw-border-[#EFF0F1]",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (isShowArchived.value = !isShowArchived.value))
          }, [
            _createElementVNode("span", null, _toDisplayString(getUiText("app-manage-orgs-button-show-archived-1")), 1),
            _createVNode(ToggleSwitch, {
              "is-checked": isShowArchived.value,
              color: "#2573E9",
              onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"])),
              "onUpdate:isChecked": _cache[2] || (_cache[2] = ($event: any) => (isShowArchived.value = $event))
            }, null, 8, ["is-checked"])
          ]),
          _createVNode(ButtonBulkActions, {
            active: showBulkActions.value,
            class: _normalizeClass(`!tw-border tw-border-1 !tw-border-solid !tw-border-[#EFF0F1] tw-mr-[15px]`),
            "button-class": `!tw-border !tw-border-solid !tw-border-[#EFF0F1]`,
            "button-class-hover": "!tw-bg-[#fcfcfd]",
            "selected-number": orgSelectedCount.value
          }, null, 8, ["active", "selected-number"]),
          _createVNode(ButtonFilter, {
            active: false,
            "button-class": `!tw-border !tw-border-solid !tw-border-[#EFF0F1]`,
            "button-class-hover": "!tw-bg-[#fcfcfd]",
            "id-popover": 'popover-btb-filter-manage-org-dropdown',
            "is-margin-right": false
          }),
          _createVNode(IconButton, {
            src: "/img/plus_icon.svg",
            onClick: _cache[4] || (_cache[4] = 
            () =>
              openCreateOrgModal(
                null,
                _unref(requestAccessDetailModalType).createRequest,
              )
          )
          })
        ])
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(`tw-w-full contain-table tw-mt-4 tw-rounded-md tw-max-h-[415px] tw-overflow-y-auto ${
        tableData.value.length === 0 ? 'tw-flex tw-items-center' : ''
      }`)
      }, [
        _createVNode(ManageOrgTable, {
          "table-data": tableData.value,
          "table-fields": organizationManageTableFields,
          "current-org": currentOrg.value,
          "onSelect:one_row": _cache[5] || (_cache[5] = ($event: any) => (handleSelectOrg($event, false))),
          "onSelect:all_row": _cache[6] || (_cache[6] = ($event: any) => (handleSelectOrg($event, true))),
          onSwitch_org: _cache[7] || (_cache[7] = ($event: any) => (switchOrg($event))),
          onLeave_org: openModalLeaveOrg,
          onEdit_request: _cache[8] || (_cache[8] = 
          (org) =>
            openCreateOrgModal(org, _unref(requestAccessDetailModalType).editRequest)
        ),
          onCreate_org: _cache[9] || (_cache[9] = 
          (org) =>
            openCreateOrgModal(org, _unref(requestAccessDetailModalType).createOrg)
        ),
          onArchive_org: handleArchiveOrgRequest,
          onDelete_org: handleDeleteOrgRequest
        }, null, 8, ["table-data", "current-org"])
      ], 2),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "button-accees",
          onClick: gotToRequest
        }, [
          _createElementVNode("span", null, _toDisplayString(getUiText("app-manage-orgs-request-org-access-text-1")), 1)
        ])
      ])
    ])
  ], 64))
}
}

})